import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { Button, Grid, units } from '@hbf/dsl';

const useStyles = makeStyles()(theme => ({
  container: {
    height: '100%',
  },
  containerDesktop: {
    maxHeight: '75vh',
    width: units.rem(45),
  },
  title: {
    marginTop: units.rem(1),
    marginBottom: units.rem(1),
  },
  content: {
    flexGrow: 1,
    overflowY: 'auto',
  },
  resetButtonDesktop: {
    marginRight: units.rem(1),
  },
  buttonsContainerDesktop: {
    background: theme.palette.grey[100],
    padding: units.rem(1.5),
    borderTop: units.border(1, 'solid', theme.palette.grey[400]),
    flexShrink: 0,
  },
  buttonsContainerMobile: {
    padding: units.rem(1),
    boxShadow: theme.shadows[4],
    flexShrink: 0,
  },
}));

interface Props {
  showResultsButtonText: string;
  onShowResultsClick: () => void;
  resetButtonText: string;
  onResetClick: () => void;
  type: 'mobile' | 'desktop';
  title?: React.ReactNode;
  updateSearchAlert?: boolean;
  updateSearchAlertText?: string;
}

const FilterLayout: React.FC<Props> = ({
  children,
  showResultsButtonText,
  onShowResultsClick,
  resetButtonText,
  onResetClick,
  type,
  title,
  updateSearchAlert = false,
  updateSearchAlertText,
}) => {
  const { classes, cx } = useStyles();

  return (
    <Grid
      container
      direction="column"
      className={cx(
        classes.container,
        type === 'desktop' && classes.containerDesktop,
      )}
      wrap="nowrap"
    >
      {title && (
        <React.Fragment>
          <Grid item className={classes.title}>
            {title}
          </Grid>
        </React.Fragment>
      )}
      <Grid item className={classes.content}>
        {children}
      </Grid>
      <Grid
        item
        container
        wrap="nowrap"
        justifyContent={type === 'desktop' ? 'flex-end' : 'space-between'}
        className={
          type === 'desktop'
            ? classes.buttonsContainerDesktop
            : classes.buttonsContainerMobile
        }
      >
        {!updateSearchAlert && (
          <Grid
            item
            xs={type === 'mobile' ? 5 : false}
            className={
              type === 'desktop' ? classes.resetButtonDesktop : undefined
            }
          >
            <Button
              fullWidth
              variant="outlined"
              onClick={onResetClick}
              data-test-locator="Reset Filter Button"
            >
              {resetButtonText}
            </Button>
          </Grid>
        )}

        <Grid
          item
          xs={type === 'mobile' ? (updateSearchAlert ? 12 : 6) : false}
        >
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={onShowResultsClick}
            data-test-locator="Update Filter Button"
          >
            {updateSearchAlert ? updateSearchAlertText : showResultsButtonText}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export { FilterLayout };
